/* 
 * Export component file to be used on project
*/

import ModalNewMedicalRequest from './ModalNewMedicalRequest.js';
export default ModalNewMedicalRequest;
